module.exports = __webpack_public_path__ + "static/img/40018 (4).39200ea.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40018 (4).webp
// module id = ADD6
// module chunks = 14